import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import Swal from 'sweetalert2';

const Loading = function() {
  const loadingState = useSelector(function(state) {
    return state.loading;
  });

  useEffect(() => {
    if (loadingState.isLoading) {
      Swal.fire({
        title: loadingState.message || 'Loading...',
        allowOutsideClick: false,
        showConfirmButton: false,
        willOpen: () => {
          Swal.showLoading();
        }
      });
    } else {
      Swal.close();
    }
  }, [loadingState.isLoading, loadingState.message]);

  return null;
};

export default Loading;